import { getDefaultStore, useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { AuthTokens } from "../model/AuthTokens";
import ClinicalProtocolType from "../model/ClinicalProtocolType";

// This persists using localStorage internally
const authTokensAtom = atomWithStorage<AuthTokens | null>("tokens", null, undefined, {
  getOnInit: true,
});
export const authTokens = () => getDefaultStore().get(authTokensAtom);
export const setAuthTokens = (tokens: AuthTokens | null) =>
  getDefaultStore().set(authTokensAtom, tokens);
export const useAuthTokensAtom = () => useAtom(authTokensAtom);

const patientPopulationAtom = atomWithStorage<ClinicalProtocolType>(
  "patientPopulation",
  "diabetes",
  undefined,
  { getOnInit: true }
);
export const usePatientPopulationAtom = () => useAtom(patientPopulationAtom);
